import { useLocalisation } from '@archipro-website/localisation';
import { getHomeCopy } from '@modules-rocco/home/api/get-home-copy';
import { SubscribeField } from '~/ui-rocco/pages/home-page/components/SubscribeField';

/**
 * Newsletter subscribe band shown between the article's body modules (Figma
 * "Intro" 2736:57255). Sits below the first rendered page-builder module, so a
 * reader meets it once they are into the article rather than at the top.
 *
 * The pill is the shared {@link SubscribeField} on its `article` variant, so it
 * posts to the same newsletter endpoint as the home page and footer. The blurb
 * is the home page's magazine copy, so the possessive prefix follows the
 * visitor's market rather than hardcoding New Zealand.
 */
export const RevampNewsletterSignup = () => {
    const { country } = useLocalisation();
    const { magazineDescription } = getHomeCopy(country);

    return (
        <section className="flex w-full flex-col gap-8 bg-white px-4.5 md:flex-row md:items-center md:justify-between md:gap-6 md:px-[3.125rem]">
            {/* 966px measure on the /16 rem scale; the copy wraps to two lines at
                the design's 33px size. */}
            <p className="m-0 font-gestura text-[1.5rem] leading-[1.25] font-normal tracking-[-0.025em] text-[#181818] md:w-[60.375rem] md:text-[2.0625rem]">
                {magazineDescription}
            </p>
            <SubscribeField variant="article" className="md:w-[38.5rem]" />
        </section>
    );
};
